import React , { PureComponent } from 'react'
import {
  Col,
  Row,
  Input,
} from 'reactstrap'
import { FormattedMessage } from 'react-intl'
import Card from '../../atoms/Card/Card'
import styled from 'styled-components'
import CheckboxGroup from '../../molecules/CheckboxGroup/CheckboxGroup'
import ResearchClassificationCard from '../../molecules/ResearchClassificationCard/ResearchClassificationCard';
import ResearchSubClassCard from '../../molecules/ResearchSubClassCard/ResearchSubClassCard';
import ResearchMeasurementUnitsCard from '../../molecules/ResearchMeasurementUnitsCard/ResearchMeasurementUnitsCard';
import ResearchSizesCard from '../../molecules/ResearchSizesCard/ResearchSizesCard';
import { LandTenureClient } from '../../../services/LandTenureClient/LandTenureClient';
import apolloClient from '../../../services/ApolloClient'
import Loading from '../../atoms/Loading/Loading'
import Select from 'react-select'

const YearInputWrapper = styled(Card)`
  width: 14rem;
`

const YearSelect = styled(Select)`
  width: 10rem;
`

const StyledCard = styled(Card)`
  height: 360px;
`

const StyledCheckboxGroup = styled(CheckboxGroup)`
  display: flex;
  flex-direction: column;
`


export default class ResearchLandTenureCards extends PureComponent {
  constructor() {
    super();

    this.state = {
      selectedYear: 2021,
      categoriesList: [],
      selectedCategories: [],
      selectedSubCatgs: [],
      subCategories: [],
      categories: [],
      themes: [],
      subThemes: [],
      themeList: [],
      defaultYear: 2021,
      ltYears: [
        {
          'label': '...',
          'value': 0
        }
      ],
      selectedThemes: [],
      selectedSubThemes: [],
      selectedMeasurement: 0,
      selectedSizes: [],
      sizes: [],
      isLoading: false
    }  

    this.onChangeLtYear = this.onChangeLtYear.bind(this);
    this.onFilterCategorySub = this.onFilterCategorySub.bind(this);
    this.onFilterSubTheme = this.onFilterSubTheme.bind(this);
    this.onSelectedSubCategory = this.onSelectedSubCategory.bind(this);
    this.onSelectedSizes = this.onSelectedSizes.bind(this);
    this.onSelectedSubThemes = this.onSelectedSubThemes.bind(this);
    this.onChangeMeasurement = this.onChangeMeasurement.bind(this);
    this.updateLtState = this.updateLtState.bind(this);
    this.doUpdateYears = this.doUpdateYears.bind(this);
    this.clearSubCategories = this.clearSubCategories.bind(this);
    
    this.doUpdateYears();
  }

  updateLtState() {
    const { 
      selectedYear, 
      selectedMeasurement,
      selectedSubThemes, 
      selectedCategories, 
      selectedSubCatgs, 
      selectedThemes,
      selectedSizes
    } = this.state;

    apolloClient.writeData({
      data: {
        research: {
          __typename: 'ResearchState',
          landTenureFilters: {
              __typename: 'ResearchLandTenureFilters',
              categories: selectedCategories,
              subcategories: selectedSubCatgs,
              themes: selectedThemes,
              subthemes: selectedSubThemes,
              sizes: selectedSizes,
              measurement: selectedMeasurement
          },
          landTenureYear: selectedYear.value
        }
      }
    })
  }

  onChangeMeasurement(selectedMeasurement) {
    this.setState({selectedMeasurement: selectedMeasurement}, this.updateLtState);
  }

  onChangeLtYear(el) {
    const currentYear = parseInt(el.value);

    if(currentYear == 0)
      return;
    
    this.setState({
      selectedYear: el,
      categoriesList: [],
      isLoading: true
    })

    if(currentYear > 999) {      
      const client = new LandTenureClient();

      client.getCategories(currentYear).then(r => {
        var nCategories = [];
        r.forEach(cat => {        
          nCategories.push({
            name: cat.name,
            value: cat.id
          });
        })
        
        this.setState({ categoriesList: nCategories, categories: r });
      });

      client.getThemes(currentYear).then(r => {
        var nThemes = [];
        r.forEach(theme => {
          nThemes.push({
            name: theme.name,
            value: theme.id,
            years: theme.years
          }); 
        });

        this.setState({ themeList: nThemes, themes: r });
      });

      client.getSizes(currentYear).then(r => {
        var nSizes = [];
        r.forEach(size => {
          nSizes.push({
            name: size.size_name,
            value: size.id_size
          }); 
        });

        this.setState({ sizes: nSizes });
      });
    }   

    this.setState({isLoading: false, 
        selectedCategories: [],         
        selectedSubCatgs: [],
        selectedThemes: [],
        selectedSubThemes: []
      });
    this.updateLtState();
  }

  onFilterCategorySub(selectedCategories) {
    this.setState({selectedCategories: selectedCategories});
    const { categories } = this.state;

    // Carrega as subcategorias 
    const subcategories = [];
    selectedCategories.forEach(cat => {
      const searchCat = categories.find(e => e.id == cat);
      if(searchCat !== undefined) {
        searchCat.subcategories.forEach(se => {
          subcategories.push({ 
            name: se.ownership_subclass_name,
            value: se.id_ownership_subclass
           });
        })
      }
    })

    this.setState({
      subCategories: subcategories
    }, this.clearSubCategories);
  }

  setPeriodRange(themes) {
    var items = [];

    themes.forEach(thm => {
      items = items.concat(thm.years);
    })

    var start = Math.min(...items);
    var end= Math.max(...items);

    apolloClient.writeData({
      data: {
        research: {
          __typename: 'ResearchState',
          landTenureRange: {
            __typename: 'ResearchLandTenureRange',
            start,
            end,
            items
          }
        }
      }
    })

    apolloClient.writeData({
      data: {
        research: {
          __typename: 'ResearchState',
          selectedPeriod: {
            __typename: 'ResearchSelectedPeriodState',
            start,
            end
          }
        }
      }
    });
  }
  
  onFilterSubTheme(theme) {
    var selectedThemes = [theme];
    this.setState({selectedThemes: selectedThemes});

    var selectedThemesList = [];
    const { themes } = this.state;

    // Carrega os sub temas 
    const subThemes = [];
    selectedThemes.forEach(thm => {
      const searchThm = themes.find(e => e.id == thm);
      if(searchThm !== undefined) {
        searchThm.subThemes.forEach(se => {
          subThemes.push({ 
            name: se.subtheme_name,
            value: se.id_subtheme
           });
        })

        selectedThemesList.push(searchThm);
      }
    })

    this.setState({
      subThemes: subThemes,
      selectedSubThemes: []
    }, this.updateLtState);
    this.setPeriodRange(selectedThemesList);
  }

  /**
   * Limpa as Subcategorias que não fazem parte das categorias selecionadas
   */
  clearSubCategories() {
    const { selectedCategories, selectedSubCatgs, categories } = this.state;

    let allowed = [];
    const catgList = categories.filter(e => selectedCategories.includes(e.id));

    catgList.forEach(cat => {
      cat.subcategories.forEach(subCat => {
        allowed.push(subCat.id_ownership_subclass);
      });
    });

    let newSelected = selectedSubCatgs.filter(sb => allowed.includes(sb));

    this.setState({
      selectedSubCatgs: newSelected
    }, this.updateLtState);
  }

  onSelectedSubCategory(selectedSubCatgs) {
    this.setState({selectedSubCatgs: selectedSubCatgs}, this.updateLtState);
  }

  onSelectedSubThemes(selectedSubThemes) {
    this.setState({selectedSubThemes: selectedSubThemes}, this.updateLtState);
  }

  onSelectedSizes(selectedSizes) {
    this.setState({selectedSizes: selectedSizes}, this.updateLtState);
  }

  doUpdateYears() {
    const { defaultYear } = this.state;

    const client = new LandTenureClient();
    client.getYears().then((r) => {
      this.setState({
        ltYears: r
      }, () => {
        
        var years = r.map(o => o.value);
        const recent = Math.max(years);

        this.onChangeLtYear({ 'label': recent.toString(),  'value': recent });
      });

    });
  }

  render() {
    const { 
        categoriesList ,
        selectedYear, 
        subThemes, 
        selectedMeasurement,
        selectedSubThemes, 
        selectedCategories, 
        selectedSubCatgs, 
        subCategories, 
        themeList, 
        selectedThemes,
        sizes,
        selectedSizes,
        isLoading,
        ltYears
      } = this.state;

    if(isLoading) {
      return (
        <Loading />
      )
    };

    return (
      <div>
      <div>        
        <Row id="YearInputWrapper">
          <Col xs="4" className="mb-4">
            <FormattedMessage
              id="survey.landtenure.year"
            >
              {(text) => ( 
                <YearInputWrapper title={text}>
                  <YearSelect
                    isSearchable={ false }
                    onChange={ (value) => {                    
                      this.onChangeLtYear(value);
                    } }
                    options={ ltYears }
                    placeholder={ text }
                    value={ selectedYear }
                    menuPortalTarget={document.getElementById("YearInputWrapper")}
                    menuShouldBlockScroll="true"
                  />
                </YearInputWrapper>
            )}
            </FormattedMessage>
         
          </Col>
        </Row>
      </div>
      <div>
        <Row>
          <Col xs="4" className="mb-4">
            <FormattedMessage
              id="survey.categories.title"
            >
                {(text) => (          
                  <StyledCard title={text}>
                    <StyledCheckboxGroup                      
                        items={ categoriesList }
                        value={ selectedCategories }
                        onChange={ this.onFilterCategorySub }                      
                    />
                  </StyledCard>
              )}
            </FormattedMessage>
          </Col>
          <Col xs="4" className="mb-4">
            <FormattedMessage
                id="survey.subcategories.title"
              >
                {(text) => (          
                  <StyledCard title={text}>
                    <StyledCheckboxGroup                      
                        items={ subCategories }
                        value={ selectedSubCatgs }
                        onChange={ this.onSelectedSubCategory }                      
                    />
                  </StyledCard>
              )}
            </FormattedMessage>
          </Col>
          <Col xs="4" className="mb-4">
            <ResearchClassificationCard 
              items={ themeList }
              value={ selectedThemes[0] }
              onChange={ this.onFilterSubTheme }
            />
          </Col>
        </Row>
        <Row>
          <Col xs="4" className="mb-4">
            <ResearchSubClassCard 
              items={ subThemes }
              value={ selectedSubThemes }
              onChange={this.onSelectedSubThemes} 
            />
          </Col>
          
          <Col xs="4" className="mb-4">
            <ResearchSizesCard 
              items={ sizes }
              value={ selectedSizes }
              onChange={this.onSelectedSizes} 
            />
          </Col>

          <Col xs="4" className="mb-4">
                <ResearchMeasurementUnitsCard 
                  items={ [{ name: "survey.measurement.propertiesnumber", value:"1" }, { name: "survey.measurement.area", value: "2"}] }
                  value={ selectedMeasurement }
                  onChange={ this.onChangeMeasurement }
                />
          </Col>
        </Row>        
      </div>
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/components/organisms/ResearchLandTenureCards/ResearchLandTenureCards.js